<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout align-center>
          {{ $t("reset.title") }}
        </v-layout>
      </v-container>
    </div>
    <v-container class="lost-container">
      <!-- <v-layout>
        <v-flex>
          <div>
            {{ $t("reset.tip") }}
          </div>
        </v-flex>
      </v-layout> -->

      <v-form ref="form">
        <v-container>
          <v-layout :column="breakpoint.smAndDown">
            <v-flex xs6>
              <v-text-field
                ref="password1"
                v-model="password1"
                :rules="nameRules"
                validate-on-blur
                :label="$t('reset.pwd_label')"
                required
                :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
                @click:append="showPassword1 = !showPassword1"
                :type="showPassword1 ? 'text' : 'password'"
                clearable
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                ref="password2"
                v-model="password2"
                :rules="nameRules"
                validate-on-blur
                :label="$t('reset.pwd_label2')"
                required
                :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
                @click:append="showPassword2 = !showPassword2"
                :type="showPassword2 ? 'text' : 'password'"
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-layout column>
        <v-flex>
          <button class="button shadow" @click="submit">
            {{ $t("reset.btn") }}
          </button>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="passwordTip" max-width="500px">
      <v-card>
        <v-card-title>
          <span>{{ tip }}</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" flat @click="passwordTip = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import account from "@/api/account";

const SECONDS = 6;

export default {
  data() {
    return {
      password1: "",
      password2: "",
      nameRules: [value => !!value || this.$t("login.rules")],
      showPassword1: false,
      showPassword2: false,
      isGettingCode: false,
      second: SECONDS,
      passwordTip: false,
      tip: this.$t("password.pwd_same")
    };
  },

  computed: {
    form() {
      return {
        password1: this.password1,
        password2: this.password2,
        guid: this.$route.query.guid
      };
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          to: { name: "account/info" },
          disabled: false,
          text: this.$t("breadcrumbs.account")
        },
        {
          to: { name: "reset-password" },
          disabled: true,
          text: this.$t("breadcrumbs.password_edit")
        }
      ];
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },

  methods: {
    submit() {
      let isFull = true;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.$refs[f].validate(true);
          isFull = false;
        }
      });

      if (isFull) {
        console.log(this.form);
        if (this.password1 != this.password2) {
          this.passwordTip = true;
          return;
        }

        this.resetPassword();
      }
    },

    async resetPassword() {
      try {
        const res = await account.reset(this.form);
        if (!res.data.isError) {
          this.$router.push({ name: "login" });
        } else {
          this.tip = res.data.msg;
          this.passwordTip = true;
        }
      } catch (e) {
        this.tip = e.response.data.msg;
        this.passwordTip = true;
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./reset-password.sass"></style>
